export const REASSIGN_FORM_INITIAL_VALUES = {
  merchantId: "",
  reason: "",
};

export const REASSIGN_VALIDATION_CONSTRAINTS = {
  reason: {
    minLength: 5,
    maxLength: 250,
  },
};

export const reassignFormValidators = {
  merchantId: (value) => (value ? null : "Merchant is required"),

  reason: (value) => {
    const len = value?.trim()?.length || 0;
    const { minLength, maxLength } = REASSIGN_VALIDATION_CONSTRAINTS.reason;

    if (len === 0) return "Reason is required";
    if (len < minLength) return `Reason must be at least ${minLength} characters`;
    if (len > maxLength) return `Reason must be at most ${maxLength} characters`;
    return null;
  },
};

export const isReassignSubmitDisabled = (form) => {
  return !!(
    form.errors.merchantId ||
    form.errors.reason ||
    !form.values.merchantId ||
    !form.values.reason?.trim()
  );
};

export const SPLIT_FORM_INITIAL_VALUES = {
  channel: "Bank",
  amount: "",
};

export const splitFormValidators = {
  channel: (value) => (value ? null : "Channel is required"),

  amount: (value, maxAmount) => {
    const numericValue = Number(value);

    if (value === "" || value == null) return "Amount is required";
    if (Number.isNaN(numericValue) || numericValue <= 0)
      return "Enter a valid amount";
    if (maxAmount != null && numericValue > maxAmount)
      return "Amount cannot exceed the transaction amount";
    return null;
  },
};
